import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import DeleteModal from '../../../../Components/Common/DeleteModal';
import { createSelector } from 'reselect';
import { toggleDeleteMarketModal } from '../../../../slices/modals/reducer';
import { removeMarket } from '../../../../slices/auth/settings/thunk';

/**
 * React component for rendering a modal to confirm and handle the deletion of a market.
 * @component
 */
function MarketDeleteModal() {
  const dispatch = useDispatch();
  // Get Delete Modal State
  const selectDeleteMarketModal = createSelector(state => state, state => state.Modal.deleteMarketModal);
  const deleteModal = useSelector(selectDeleteMarketModal);
  // Select Client Id
  const getSelectedClientId = createSelector((state) => state, (state) => state.Settings.selectedClientId);
  const clientId = useSelector(getSelectedClientId);
  // Select Brand Id
  const getSelectedBrandId = createSelector((state) => state, (state) => state.Settings.selectedBrandId);
  const brandId = useSelector(getSelectedBrandId);
  // Select Market Id
  const getSelectedMarketId = createSelector((state) => state, (state) => state.Settings.selectedMarketId);
  const marketId = useSelector(getSelectedMarketId);

  /**
  * Handles the deletion modal action by dispatching a Redux action to remove a market.
  */
  async function handleDeleteModal() {
    await dispatch(removeMarket(marketId, clientId, brandId));
    dispatch(toggleDeleteMarketModal());
  }
  return (
    <DeleteModal
      show={deleteModal}
      onCloseClick={() => dispatch(toggleDeleteMarketModal())}
      onDeleteClick={handleDeleteModal}
    />
  )
}

export default MarketDeleteModal
